__turbopack_context__.v({
  "Icon": "KX0d8G_Icon",
  "material-symbols-outlined": "KX0d8G_material-symbols-outlined",
  "material-symbols-rounded": "KX0d8G_material-symbols-rounded",
  "material-symbols-sharp": "KX0d8G_material-symbols-sharp",
  "skeleton-loading": "KX0d8G_skeleton-loading",
});
